import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import {
  onUserNameChanged,
  onEmailChanged,
  onUserEmailVerified } from '../../reducers/authState'
import User from './indexC'

const mapStateToProps = (state) => {
  const { name, email, emailVerified } = state.authState
  return {
    userName: name,
    email: email,
    emailVerified: emailVerified,
    account: state.account
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAccount: () => dispatch(push('/account')),
    onLogout: () => {
      dispatch(push('/'))
      window.location.reload()
    },
    onUpdateName: name => dispatch(onUserNameChanged(name)),
    onUpdateEmail: email => dispatch(onEmailChanged(email)),
    onEmailVerified: () => dispatch(onUserEmailVerified()),
    onSuccessReload: () => dispatch(push('/user'))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(User)



// WEBPACK FOOTER //
// ./src/components/User/index.js